import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons';
import { Flex, Typography } from 'antd';
import { AnalyzeStatuses } from 'constants/patients';

import { StyledStatus } from './styled';

const { Paragraph } = Typography;

const capitalizeFirstLetter = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const renderStatus = (status: string, t: (key: string) => string) => {
  switch (status) {
    case AnalyzeStatuses.high:
      return (
        <StyledStatus $status="high">
          <CaretUpOutlined />
          <Paragraph>{t('patient.high')}</Paragraph>
        </StyledStatus>
      );
    case AnalyzeStatuses.norm:
      return (
        <StyledStatus $status="norm">
          <Paragraph>{t('patient.normal')}</Paragraph>
        </StyledStatus>
      );
    case AnalyzeStatuses.low:
      return (
        <StyledStatus $status="low">
          <CaretDownOutlined />
          <Paragraph>{t('patient.low')}</Paragraph>
        </StyledStatus>
      );
    default:
      return <Paragraph>-</Paragraph>;
  }
};

export const renderReferenceRange = (
  referenceRange: string | { [key: string]: string }
) => {
  if (typeof referenceRange === 'string') {
    return <Paragraph style={{ margin: 0 }}>{referenceRange}</Paragraph>;
  } else if (typeof referenceRange === 'object' && referenceRange !== null) {
    return (
      <Flex vertical gap={4}>
        {Object.entries(referenceRange).map(([key, value]) => (
          <Paragraph style={{ margin: 0 }} key={key}>
            {capitalizeFirstLetter(key)}: {value}
          </Paragraph>
        ))}
      </Flex>
    );
  } else {
    return <Paragraph>-</Paragraph>;
  }
};
